import { render, staticRenderFns } from "./TradesmanCateList.vue?vue&type=template&id=2c95d067&"
import script from "./TradesmanCateList.vue?vue&type=script&lang=js&"
export * from "./TradesmanCateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports